<template>
  <div :class="['chat-input-bar', { 'chat-input-bar--locked': locked }]">
    <div v-if="locked" class="chat-input-row">
      <svg class="chat-locked-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      <span class="chat-locked-text">{{ lockedText }}</span>
    </div>
    <template v-else>
      <div class="chat-input-row">
        <input
          v-model="inputText"
          class="chat-input"
          placeholder="Reply to continue..."
          :disabled="loading"
          @keydown.enter="handleSend"
        />
        <button class="chat-input-send" :disabled="loading" @click="handleSend">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
          </svg>
        </button>
      </div>
      <span v-if="cardMismatchHint" class="chat-input-hint">{{ cardMismatchHint }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ChatInputBar',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    lockedText: {
      type: String,
      default: 'Chat closed — entry point created. Edit outputs directly in the panel.'
    },
    cardOptions: {
      type: Array,
      default: null
    }
  },
  emits: ['send'],
  data () {
    return {
      inputText: ''
    }
  },
  computed: {
    cardMismatchHint () {
      const text = this.inputText.trim()
      if (!text || !this.cardOptions || !this.cardOptions.length) return ''
      const needle = text.toLowerCase()
      const matches = this.cardOptions.some(option => {
        const opt = option.toLowerCase()
        return opt === needle || opt.includes(needle) || needle.includes(opt)
      })
      return matches ? '' : `This doesn't match any of the options above — please pick one or check your spelling.`
    }
  },
  methods: {
    handleSend () {
      const text = this.inputText.trim()
      if (!text) return
      this.$emit('send', text)
      this.inputText = ''
    },
    clear () {
      this.inputText = ''
    }
  }
}
</script>

<style scoped src="./ChatInputBar.css"></style>



// WEBPACK FOOTER //
// ChatInputBar.vue?35b2eef0